type Color = `#${string}`;

export const computerColor: Color = '#637CEF';
export const tabletColor: Color = '#E3008C';
export const mobileColor: Color = '#2AA0A4';
export const connectedTVColor: Color = '#9373C0';
